import React, { FC, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import PopUpContainer from 'src/components/common/modal/PopUp';
import OtpInput from 'src/components/common/OtpInput';
import styles from './styles.module.scss';

const OTP_INPUT_LENGTH: any = {
  safe1: 2,
  safe2: 3,
  safe3: 6,
};

type IProps = {
  isOpen: boolean;
  onClose: () => void;
  safeName: 'safe1' | 'safe2' | 'safe3' | '';
  safeData: any;
  onOpenSafe: (safe: 'safe1' | 'safe2' | 'safe3', code: string) => void;
};

const OpenSafeDialog: FC<IProps> = ({ isOpen, onClose, safeName, onOpenSafe }) => {
  const { t }: Translation = useTranslation();

  // States
  const [otpVal, setOtpVal] = useState<string>('');

  const onCloseHandler = (): void => {
    setOtpVal('');
    onClose();
  };

  const handleChange = (otp: string): void => {
    setOtpVal(otp);
  };

  const onSubmitHandler = (): void => {
    if (safeName && otpVal && otpVal.length === OTP_INPUT_LENGTH[safeName]) {
      onOpenSafe(safeName, otpVal);
      setOtpVal('');
    }
  };

  return (
    <PopUpContainer
      isOpen={isOpen}
      handleClose={onCloseHandler}
      hasOverlay
      title={t('safe_promo.openSafeModalTitle')}
      description={t('safe_promo.openSafeModalDescription')}
      zIndex={250}
      handleOK={onSubmitHandler}
      handleCancel={onCloseHandler}
      disabled={!otpVal || otpVal.length < OTP_INPUT_LENGTH[safeName]}
    >
      <div className={styles.dialog_body}>
        <OtpInput
          length={OTP_INPUT_LENGTH[safeName]}
          value={otpVal}
          onChange={handleChange}
          size={isMobileOnly ? 'md' : 'lg'}
        />
      </div>
    </PopUpContainer>
  );
};

export default OpenSafeDialog;
